<script setup lang="ts">
import FormProduto from '../components/form-produto.vue'
import { useProdutoStore } from '../store/useProdutoStore'

definePage({
  meta: {
    navActiveLink: 'admin-produto',
    action: 'edit',
    subject: 'produto',
  },
})

const store = useProdutoStore()
const router = useRouter()

const {
  fetchItem,
} = store

fetchItem(router.currentRoute.value.params.id)
</script>

<template>
  <FormProduto is-editing />
</template>
